// extracted by mini-css-extract-plugin
export default {"hero":"hero-module--hero--1YkMT","bottomRightBG":"hero-module--bottomRightBG--2w1ZZ","topLeftBG":"hero-module--topLeftBG--1mXvc"};